import { render, staticRenderFns } from "./PurchaseInfoAdx.vue?vue&type=template&id=950ba4c8"
import script from "./PurchaseInfoAdx.vue?vue&type=script&lang=js"
export * from "./PurchaseInfoAdx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports